module.exports = __webpack_public_path__ + "img/ceramic-happy.e0fcca27.jpg";